module.exports = __webpack_public_path__ + "static/img/BANK-E-AUCTION-LOGO-icon.3ce4f771.png";